import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { API } from '@service/api';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-device-content-list',
  templateUrl: './device-content-list.component.html',
})
export class DeviceContentListComponent implements OnInit {
  @Input() deviceSerial: any;
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() isRefresh = new EventEmitter<boolean>();
  // 列表数据
  listData: any[] = [];
  tableLoading = false;
  set visible(ev: boolean) {
    this.isVisible = ev;
    this.isVisibleChange.emit(ev);
  }

  // tslint:disable-next-line:typedef
  get visible() {
    return (this.isVisible = false);
  }

  info: any;
  // 新增编辑表单
  form: any;
  title = '发布内容';
  loading = false;

  constructor(
    private api: API,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public http: _HttpClient,
    public msg: NzMessageService,
    public notify: NzNotificationService,
  ) {}

  ngOnInit(): void {
    this.getAuthDetail();
  }

  // 获取详情
  getAuthDetail(): void {
    if (this.deviceSerial) {
      this.tableLoading = true;
      this.http.get(this.api.DEVICE_CONTENT_LIST, { deviceSerial: this.deviceSerial }).subscribe((e) => {
        if (e.code === 200) {
          this.listData = e.data;
        }
        this.tableLoading = false;
      });
    }
  }

  close(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
  }
}
